<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="row vld-parent" ref="containerDash" style="min-height: 400px">

      <div class="col-lg-12 order-0 mb-4">
        <div class="card">
          <div class="row d-flex align-items-end">
            <div class="col-sm-7">
              <div class="card-body">
                <h5 class="card-title text-primary">Bienvenido al Índice de Desarrollo Empresarial Sostenible! 🎉</h5>
                <p class="mb-4">
                  Resumen de avance
                </p>
              </div>
            </div>
            <div class="text-sm-left col-sm-5 text-center">
              <div class="card-body px-0 px-md-4 pb-0">
                <img
                    src="../../assets/img/illustrations/man-with-laptop-light.png"
                    height="140"
                    alt="View Badge User"
                    data-app-dark-img="illustrations/man-with-laptop-dark.png"
                    data-app-light-img="illustrations/man-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Total Revenue -->
      <div class="col-12 order-1">
        <div class="input-group mb-3">
          <label class="input-group-text" for="periodSelected">Periodo</label>
          <select-custom v-on:change="getDashboard" id="periodSelected" v-model="year" :options="years"/>
        </div>
      </div>
      <div class="col-12 order-2" v-if="loading === false">
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4" v-if="dashboard">
          <div v-for="dimension in dashboard.dimensions" :key="dimension.id" class="col">
            <div class="card">
              <div class="ml-3 mr-3">
                <apexchart type="radialBar" height="150"
                           :options="this.getLabel(dimension.responseCount,dimension.questionCount)"
                           :series="[dimension.percent]"></apexchart>
              </div>
              <div class="text-center fw-semibold mb-2">{{ dimension.name }}</div>
              <div class="text-center  pt-3 mb-3" v-if="dimension.status === 'OPEN'">
                <a :href="$router.resolve({name: 'dimensionPeriod', params: { id: dimension.id, period: year }}).href"  class="btn btn-sm btn-label-primary">Continuar</a>
              </div>
              <div class="text-center  pt-3 mb-3" v-if="dimension.status === 'CLOSE'">
                <a :href="$router.resolve({name: 'dimensionPeriod', params: { id: dimension.id, period: year }}).href" class="btn btn-sm btn-secondary">Finalizada</a>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else-if="terms === false">
          <form id="formTerms" class="mb-3 needs-validation" @submit.prevent="handleTerms">
            <div class="card-body mb-4">

              <h1 style='margin-top:12.0pt;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:21px;font-family:"Calibri Light",sans-serif;color:#2F5496;font-weight:normal;text-align:center;'>T&eacute;rminos y condiciones de uso de la Plataforma iDES.</h1>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>La Plataforma iDES (&Iacute;ndice Desarrollo Empresarial Sostenible), es una herramienta creada por SOFOFA para la medici&oacute;n y gesti&oacute;n de criterios medioambientes, sociales y de gobiernos corporativos, que permitir&aacute; recopilar la informaci&oacute;n de las empresas socias que -voluntariamente- decidan participar en la herramienta, con el objeto de canalizar informaci&oacute;n a trav&eacute;s de esta, que les permita &nbsp;obtener informes individuales y confidenciales acerca de su estado en comparaci&oacute;n con el promedio de las empresas que participen, por industria y con un est&aacute;ndar de referencia.</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>A continuaci&oacute;n, le solicitamos leer detenida y atentamente los siguientes T&eacute;rminos y Condiciones de Uso, los cuales, una vez aceptados, le permitir&aacute;n &nbsp; acceder a la herramienta:</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
              <ol style="list-style-type: circle;">
                <li>Lea cuidadosamente la encuesta. Las empresas participantes solo podr&aacute;n remitir una vez sus respuestas en la Plataforma.</li>
                <li>Las respuestas ser&aacute;n entregadas por el usuario que ser&aacute; validado en representaci&oacute;n de su empresa. No obstante, a trav&eacute;s de la cuenta, se podr&aacute; otorgar acceso a otros colaboradores de la empresa para solicitar apoyo en el levantamiento de informaci&oacute;n de preguntas espec&iacute;ficas.</li>
                <li>SOFOFA adoptar&aacute; las medidas razonables para efectos de disminuir, en la medida de lo posible, los riesgos de vulneraci&oacute;n o &ldquo;hackeo&rdquo; de la Plataforma. Concretamente, se compromete a la adopci&oacute;n de las siguientes acciones de mitigaci&oacute;n de riesgos de hackeo:<ol style="list-style-type: circle;">
                  <li>Datos ser&aacute;n almacenados mediante encriptaci&oacute;n</li>
                  <li>Servidor est&aacute;n protegidos en base a los m&aacute;ximos est&aacute;ndar de seguridad entregados por AWS (Amazon Web Service)</li>
                  <li>El acceso a la plataforma estar&aacute; restringido en base a autorizaciones</li>
                </ol>
                </li>
              </ol>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;margin-left:35.4pt;text-align:justify;'>No obstante, lo anterior, SOFOFA en ning&uacute;n caso ser&aacute; responsable de la filtraci&oacute;n de informaci&oacute;n que podr&iacute;a ocurrir en caso de ser vulnerada o &ldquo;hackeada&rdquo; la presente Plataforma.</p>
              <ol style="list-style-type: circle;">
                <li>Ninguno de los colaboradores de SOFOFA, ni de sus proveedores para este proyecto, le pedir&aacute;n entregar la informaci&oacute;n asociada a esta herramienta a trav&eacute;s de un canal externo a esta Plataforma, salvo la solicitud de registro inicial que ser&aacute; realizada a trav&eacute;s de correo oficial del dominio de SOFOFA. De igual manera, la empresa no deber&aacute; enviar de manera voluntaria las respuestas y/o la informaci&oacute;n asociada a esta herramienta por ning&uacute;n medio diferente a la presente Plataforma. SOFOFA no considerar&aacute; ninguna informaci&oacute;n enviada para estos efectos a trav&eacute;s de un medio distinto de la Plataforma.</li>
                <li>Las respuestas que entregue en nombre de la empresa que representa ser&aacute;n de exclusivo conocimiento de su empresa. Ni SOFOFA, ni ninguno de sus colaboradores, o las dem&aacute;s empresas participantes, podr&aacute;n acceder a las respuestas particulares que entregue ni al informe que se genere para su empresa a partir de las mismas, las cuales ser&aacute;n configuradas de manera tal que sean encriptadas y sin acceso por parte del personal de SOFOFA o las dem&aacute;s empresas participantes. Lo anterior es para toda la informaci&oacute;n entregada por la empresa, salvo aquellas asociadas a la identificaci&oacute;n de la empresa y del colaborador de esta que estar&aacute; a cargo de contestar la herramienta, concretamente:<ol style="list-style-type: circle;">
                  <li>Raz&oacute;n social de la empresa</li>
                  <li>RUT de la empresa</li>
                  <li>Rubro principal de la empresa</li>
                  <li>Tama&ntilde;o de la empresa</li>
                  <li>Nombre completo, correo y tel&eacute;fono de la persona responsable de llenar la herramienta</li>
                </ol>
                </li>
                <li>Independiente del punto anterior, SOFOFA si tendr&aacute; acceso a la siguiente informaci&oacute;n:<ol style="list-style-type: circle;">
                  <li>Estado de avance o de completitud de la empresa en relaci&oacute;n con las respuestas a las preguntas dispuestas en la herramienta, entendida como el porcentaje de respuestas contestadas y guardadas sobre el total de preguntas obligatorias de la herramienta.</li>
                  <li>Respuestas promedio a nivel agregado por tama&ntilde;o de empresa, clasificaci&oacute;n de tipo de clientes (consumidor final o industrial), tipo de empresa (holding corporativo o epresa productiva) o industria, en base a la siguiente clasificaci&oacute;n industrial:<ul style="list-style-type: square;">
                    <li>Agroindustrial</li>
                    <li>Alimentos</li>
                    <li>Automotriz</li>
                    <li>Bebidas/ Licores</li>
                    <li>Bienes de Consumo</li>
                    <li>Cementos</li>
                    <li>Educaci&oacute;n</li>
                    <li>Energ&iacute;a el&eacute;ctrica</li>
                    <li>Entretenci&oacute;n</li>
                    <li>Forestal/ Papel</li>
                    <li>Industria Manufacturera</li>
                    <li>Ingenier&iacute;a</li>
                    <li>M&aacute;quinas/ Equipos</li>
                    <li>Medios</li>
                    <li>Metalurgia</li>
                    <li>Miner&iacute;a</li>
                    <li>Multisector</li>
                    <li>Pesquero</li>
                    <li>Petr&oacute;leo/ Gas</li>
                    <li>Qu&iacute;mica/Farmacia</li>
                    <li>Retail</li>
                    <li>Sanitarias</li>
                    <li>Servicios de Consultor&iacute;a</li>
                    <li>Servicios de Salud</li>
                    <li>Servicios Financieros</li>
                    <li>Software/ TI</li>
                    <li>Telecomunicaciones</li>
                    <li>Transporte/ Log&iacute;stica</li>
                    <li>Otros</li>
                  </ul>
                  </li>
                </ol>
                </li>
                <li>La informaci&oacute;n agregada a la cual podr&aacute; acceder SOFOFA ser&aacute; obtenida a trav&eacute;s de los siguientes medios de c&aacute;lculo:<ol style="list-style-type: circle;">
                  <li>Promedio aritm&eacute;tico de respuestas en caso de que las posibilidades de respuesta sean num&eacute;ricas o porcentuales</li>
                  <li>Tabla de frecuencia de respuesta en caso de que la pregunta sea de diversas opciones (por ejemplo, escalas graduales, preguntas dicot&oacute;micas, u otro similar)</li>
                </ol>
                </li>
                <li>SOFOFA podr&aacute; publicar la informaci&oacute;n agregada que se especifica en el punto anterior, as&iacute; como el est&aacute;ndar que defina SOFOFA en relaci&oacute;n a cada dimensi&oacute;n de la herramienta. S&oacute;lo podr&aacute; referirse o hacer p&uacute;blico los nombres de las empresas que participan en esta iniciativa de manera conjunta.</li>
                <li>Por su lado, la empresa, al aceptar estas condiciones, tendr&aacute; la prohibici&oacute;n de difundir las preguntas y escalas de respuestas asociadas a esta herramienta de manera p&uacute;blica. S&oacute;lo puede compartir dicha informaci&oacute;n de manera interna en su empresa en caso de requerir informaci&oacute;n para responder en la Plataforma, velando y haci&eacute;ndose responsable ante SOFOFA y terceros de que la empresa y sus colaboradores mantendr&aacute;n la debida confidencialidad de dicha informaci&oacute;n, debiendo adoptar de manera inmediata todas las acciones y medidas que resulten necesarias para mantener la debida confidencialidad de esta en caso de que dicha obligaci&oacute;n sea infringida.</li>
                <li>La empresa tendr&aacute; libertad de comunicar al p&uacute;blico sus resultados finales, sin detallar las preguntas y escalas de respuestas, tal como se establece en el punto anterior.</li>
                <li>La empresa, y particularmente el responsable de la empresa encargado de contestar esta herramienta, se compromete a completarla y ser&aacute; responsable de la veracidad de la informaci&oacute;n entregada respecto de su empresa.</li>
              </ol>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>&nbsp;</p>
              <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'>Al aceptar los T&eacute;rminos y Condiciones de Uso, la empresa que usted representa declara que los acepta libremente y en su totalidad, sin reserva de ninguna especie.</p>
              <div class="mb-3 mt-5">
                <div class="form-check" :class="{ 'is-invalid': v$.form.terms.$error }">
                  <input v-model.trim="v$.form.terms.$model" :class="{ 'is-invalid': v$.form.terms.$error }"
                         class="form-check-input" type="checkbox" id="terms-conditions" name="terms"/>
                  <label class="form-check-label" for="terms-conditions">
                    Acepto los Términos y condiciones iDES
                  </label>
                </div>
                <div class="invalid-feedback" v-if="v$.form.terms.required.$invalid">
                  {{ t("validations.required", {"property": "Políticas"}) }}
                </div>
              </div>
              <div class="text-center d-flex justify-content-center">
                <button type="submit" :disabled="loading" class="btn btn-primary d-grid ">Ingresar</button>
              </div>
            </div>
          </form>
        </div>
        <div class="card" v-else>
          <form id="formCompany" class="mb-3 needs-validation" @submit.prevent="handleCompanyParam">
            <div class="card-header text-center">
              <h4>Para continuar, por favor completar los siguientes campos</h4>
            </div>
            <div class="card-body mb-4">
              <div class="mb-3">
                <label for="companyType" class="form-label">Tipo de empresa</label>
                <select-custom v-model.trim="form.type"
                               id="companyType"
                               name="companyType"
                               placeholder="Ingresa el nombre de la Empresa" :options="optionCompany.type"/>

                <div class="invalid-feedback">
                  Tipo de empresa es requerido
                </div>
              </div>
              <div class="mb-3">
                <label for="companyTypeClient" class="form-label">Tipo de clientes principales</label>
                <select-custom v-model.trim="form.typeClient"
                               id="companyTypeClient"
                               name="companyTypeClient"
                               placeholder="Ingresa el nombre de la Empresa" :options="optionCompany.typeClient"/>

                <div class="invalid-feedback" >
                  Tipo de clientes principales es requerido
                </div>
              </div>
              <div class="mb-3">
                <label for="companyRange" class="form-label">Tamaño de la empresa (cantidad de colaboradores)</label>
                <select-custom v-model.trim="form.range"
                               id="companyRange"
                               name="companyRange"
                               placeholder="Ingresa el nombre de la Empresa" :options="optionCompany.range"/>
                <div class="invalid-feedback" v-if="this.form.range === 0">
                  Rango de facturación anual es requerido
                </div>
              </div>
              <div class="text-center d-flex justify-content-center">
                <button type="submit"  :disabled="this.form.range == 0 || this.form.type == 0 || this.form.typeClient  == 0" class="btn btn-primary d-grid ">Continuar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-12 order-2" style="min-height: 400px" v-if="loading === true">
        <div id="overlay" class="d-flex justify-content-center">
          <div class="spinner-grow spinner text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <!--/ Total Revenue -->
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import SelectCustom from "@/components/SelectCustom";

import DashboardService from '../../services/dashboard.service';
import EventBus from "../../common/EventBus";

import useVuelidate from "@vuelidate/core";
import {required, sameAs} from "@vuelidate/validators";
import PeriodService from "@/services/period.service";


// @ is an alias to /src
export default {
  name: 'HomeView',
  components: {
    'apexchart': VueApexCharts,
    'SelectCustom': SelectCustom
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data: function () {
    return {
      series: [0],
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar'
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '16px',
                color: undefined,
                offsetY: 35
              },
              value: {
                offsetY: -10,
                fontSize: '16px',
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                }
              }
            }
          }
        },
        labels: ['0/3'],
      },
      loading: true,
      dashboard: false,
      terms: false,
      companyParam: false,
      form: {
        terms: false,
        type: 0,
        typeClient: 0,
        range: 0
      },
      optionCompany: {
        type: [
          {
            value: "0",
            label: "Selecciona un tipo de empresa"
          },
          {
            value: "1",
            label: "Holding de inversión/grupo corporativo"
          },
          {
            value: "2",
            label: "Empresa de producción de bienes y servicios"
          }
        ],
        typeClient: [
          {
            value: "0",
            label: "Selecciona un tipo de cliente"
          },
          {
            value: "1",
            label: "Industriales (B2B)"
          },
          {
            value: "2",
            label: "Consumidor final - Ciudadanos (B2C)"
          }
        ],
        range: [
          {
            value: "0",
            label: "Selecciona Tamaño de la empresa (cantidad de colaboradores)"
          },
          {
            value: "1",
            label: "Menos de 1000 colaboradores"
          },
          {
            value: "2",
            label: "Entre 1000 y 5000 colaboradores "
          },
          {
            value: "3",
            label: "Más de 5000 colaboradores"
          }
        ],
      },
      years: [],
      year: undefined,
    };
  },
  validations() {
    return {
      form: {
        terms: {
          required,
          okTerms: sameAs(true)
        }
      }
    };
  },
  mounted() {
    this.getPeriods();
  },
  methods: {
    async getPeriods() {
      this.loading = true;
      let that = this;
      PeriodService.getPeriods().then(
          response => {
            if (response.data.success) {
              that.years = [];
              for (const row in response.data.data.items) {
                that.years.push({
                  value: response.data.data.items[row].id,
                  label: response.data.data.items[row].name,
                });
              }
              that.year = response.data.data.default.id;
              that.getDashboard();
            }
          },
          error => {
            this.content =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            if (error.response && (error.response.status === 403 || error.response.status === 401)) {
              EventBus.dispatch("logout");
            }
          }
      );
    },
    async getDashboard() {
      this.dashboard = false;
      let that = this;
      DashboardService.getDashbaord(this.year).then(
          response => {
            if (response.data.success && response.data.data.terms && response.data.data.company) {
              that.dashboard = response.data.data;
              that.terms = response.data.data.terms;
              that.company = response.data.data.company;
            } else if (response.data.success) {
              that.terms = response.data.data.terms;
              that.form.terms =   that.terms;
              that.companyParam = response.data.data.company;
            }
            that.loading = false;
          },
          error => {
            this.content =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            if (error.response && (error.response.status === 403 || error.response.status === 401)) {
              EventBus.dispatch("logout");
            }
          }
      );
    },
    async handleTerms() {
      const result = await this.v$.$validate()
      if (result) {
        this.loading = true;
        DashboardService.putTerms().then(
            response => {
              console.log(response.data);
              this.getDashboard();
            },
            error => {
              this.content =
                  (error.response && error.response.data && error.response.data.message) ||
                  error.message ||
                  error.toString();
              if (error.response && (error.response.status === 403 || error.response.status === 401)) {
                EventBus.dispatch("logout");
              }
            }
        );
      } else {
        console.log("Faltan Term")
      }
    },
    async handleCompanyParam() {

      if (this.form.range > 0 && this.form.type > 0 && this.form.typeClient  > 0) {
        this.loading = true;
        DashboardService.putCompany(this.form).then(
            response => {
              console.log(response.data);
              this.getDashboard();
            },
            error => {
              this.content =
                  (error.response && error.response.data && error.response.data.message) ||
                  error.message ||
                  error.toString();
              if (error.response && (error.response.status === 403 || error.response.status === 401)) {
                EventBus.dispatch("logout");
              }
            }
        );
      }else {
        console.log("Faltan PAram company",this.form )
      }
    },

    getLabel(questionResponse, questionsCount) {
      let options = Object.assign({}, this.chartOptions);
      options.labels = [questionResponse + '/' + questionsCount];
      return options
    }
  }
}
</script>
